import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoadingGeneration from '../../shared/ui/loading-generation/LoadingGeneration';
import { useAppDispatch } from '../../store/store';
import { createQuickPost } from '../../shared/api/textProjectApi';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const GenerateQuickPostPage = () => {
    const { platform } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const handleQuickPost = async () => {
            const error = searchParams.get('error');
            const source = searchParams.get('source');
            const page_id = searchParams.get('page_id');
            console.log('source', source);
            console.log('error', error);

            if (error) {
                navigate(`/onboarding?error=${error}&step=2&source=${source}`);
                return;
            }

            if (platform) {
                try {
                    const result = await dispatch(
                        createQuickPost({ platform: platform, page_id: page_id }),
                    ).unwrap();
                    console.log('result', result);
                    if (result && result.id) {
                        navigate(`/ready-post/${result.id}`);
                    }
                } catch (error) {
                    if (source === 'onboarding') {
                        navigate('/onboarding?error=quick_post_failed&step=2');
                    } else {
                        navigate('/dashboard');
                        toast.error('Failed to create quick post');
                    }
                }
            }
        };

        handleQuickPost();
    }, [platform, dispatch, navigate, searchParams]);

    return <LoadingGeneration />;
};

export default GenerateQuickPostPage;
